import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { XamaLogo, CheckIcon } from '../../assets/svgs/icons';
import {
  completeStripeCheckoutReturn,
  hasStripeCheckoutReturn,
} from '../../utils/stripeCheckoutReturn';
import styles from './styles.module.css';

const PricingSuccess = () => {
    const navigate = useNavigate();

    useEffect(() => {
        if (!hasStripeCheckoutReturn(window.location.search)) {
            return
        }

        const queryParams = new URLSearchParams(window.location.search)
        const sessionId = queryParams.get('session_id')

        completeStripeCheckoutReturn(sessionId || undefined)
    }, [])

    return (
        <div className={styles.container}>
            <header className={styles.header}>
                <div className={styles.headerContent}>
                    <div
                        className={styles.logoContainer}
                        onClick={() => navigate('/')}
                        style={{ cursor: 'pointer' }}
                    >
                        <XamaLogo width={110} height={30} />
                    </div>
                </div>
            </header>

            <main className={styles.main}>
                <motion.div
                    initial={{ scale: 0.8, opacity: 0 }}
                    animate={{ scale: 1, opacity: 1 }}
                    className={styles.successCard}
                >
                    <div className={styles.iconCircle}>
                        <CheckIcon size={40} color="#fff" />
                    </div>

                    <h1 className={styles.title}>
                        Pagamento Recebido!
                    </h1>

                    <p className={styles.message}>
                        Enviamos um e-mail para você com as instruções para acessar sua conta e definir sua senha.
                    </p>

                    <div className={styles.steps}>
                        <div className={styles.stepItem}>
                            <span className={styles.stepNumber}>1</span>
                            <p>Verifique sua caixa de entrada (e a pasta de spam).</p>
                        </div>
                        <div className={styles.stepItem}>
                            <span className={styles.stepNumber}>2</span>
                            <p>Clique no link enviado para ativar sua conta.</p>
                        </div>
                        <div className={styles.stepItem}>
                            <span className={styles.stepNumber}>3</span>
                            <p>Comece a criar seus posts com IA!</p>
                        </div>
                    </div>

                    <button
                        className={styles.button}
                        onClick={() => navigate('/SignIn')}
                    >
                        Ir para o Login
                    </button>
                </motion.div>
            </main>
        </div>
    );
};

export default PricingSuccess;
